const activity = {
  activity: "กิจกรรม", // translated
  activities: "กิจกรรม", // translated
  dates: "วันที่", // translated
  location: "ที่ตั้ง", // translated
  languages: "ภาษา", // translated
  categories: "หมวดหมู่", // translated
  ticketOption: "ตัวเลือกตั๋ว", // translated
  numberOfRatings: "จำนวนการให้คะแนน", // translated
  meetingPointInfo: "ข้อมูลจุดนัดพบ", // translated
  meetingPoint: "จุดนัดพบ", // translated
  meetingPoints: "จุดนัดพบ", // translated
  providedBy: "ให้บริการโดย", // translated
  expirationDate: "วันหมดอายุ", // translated
  groupSize: "ขนาดกลุ่ม", // translated
  features: "คุณสมบัติ", // translated
  basedOn: "ขึ้นอยู่กับ", // translated
  reviewsFromVerCustomers: "รีวิวจากลูกค้าที่ได้รับการตรวจสอบแล้ว", // translated
  excellent: "ยอดเยี่ยม", // translated
  great: "ยอดเยี่ยม", // translated
  average: "เฉลี่ย", // translated
  poor: "ยากจน", // translated
  bad: "แย่", // translated
  onlyBookedCustomersTooltip: "เฉพาะลูกค้าที่จองกิจกรรมนี้เท่านั้นที่สามารถแสดงความคิดเห็นได้", // translated
  noReviewsYet: "ขณะนี้ยังไม่มีรีวิวสำหรับกิจกรรมนี้", // translated
  backToActivitiesList: "กลับสู่รายการกิจกรรม", // translated
  getPrices: "รับราคา", // translated
  availabilityAndPrices: "ห้องว่างและราคา", // translated
  ticketOptions: "ตัวเลือกตั๋ว", // translated
  ticketInfo: "ข้อมูลตั๋ว", // translated
  selectYourTickets: "เลือกตั๋วของคุณ", // translated
  product: "ผลิตภัณฑ์", // translated
  total: "ทั้งหมด", // translated
  slot: "สล็อต", // translated
  language: "ภาษาไทย", // translated
  tickets: "ตั๋ว", // translated
  ticketsFor: "ตั๋วสำหรับ", // translated
  previousStep: "ขั้นตอนก่อนหน้า", // translated
  onlyAvailableInEnglish: "มีเฉพาะในภาษาอังกฤษเท่านั้น", // translated
  guest: "แขก", // translated
  leadGuest: "แขกรับเชิญ", // translated
  adult: "ผู้ใหญ่", // translated
  child: "เด็ก", // translated
  pleaseSelectAdult: "โปรดเลือกผู้ใหญ่อย่างน้อยหนึ่งคน", // translated
  notAvailableActivity: "สินค้านี้ไม่มีจำหน่าย", // translated
  required: "ที่จำเป็น", // translated
  pickupPoint: "จุดรับของ", // translated
  pickupPoints: "จุดรับ", // translated
  ticketType: "ประเภทตั๋ว", // translated
  anonymous: "ไม่ระบุชื่อ", // translated
  printedVoucher: "ยอมรับบัตรกำนัลที่พิมพ์แล้ว", // translated
  mobileVoucher: "ยอมรับบัตรกำนัลบนมือถือ", // translated
  mixedVoucher: "ยอมรับบัตรกำนัลบนมือถือหรือที่พิมพ์ออกมา", // translated
  safetyMeasures: "ใช้มาตรการความปลอดภัย", // translated
  doThisBecause: "ทำสิ่งนี้เพราะว่า", // translated
  safetyInfo: "ข้อมูลความปลอดภัย", // translated
  reviewsHighestFirst: "จำนวนบทวิจารณ์ (สูงสุดก่อน)", // translated
  bookingFee: "ค่าธรรมเนียมการจอง", // translated
  startDate: "วันที่เริ่มต้น", // translated
  endDate: "วันที่สิ้นสุด", // translated
  cancellationDeadlineAndFees: "กำหนดเวลาการยกเลิกและค่าธรรมเนียม", // translated
  resetTickets: "รีเซ็ตตั๋ว", // translated
  instantConfirmation: "การยืนยันทันที", // translated
  clickResetBtn: "คลิกปุ่มรีเซ็ตเพื่อเริ่มการเลือกของคุณอีกครั้ง", // translated
};


export default activity;
